import { FC } from "react"

import { Alert } from "@mui/material"
import { useTranslation } from "react-i18next"

const SyncedClassWarning: FC = () => {
  const { t } = useTranslation()

  return (
    <Alert
      severity="info"
      role="status"
      sx={{
        bgcolor: "mockup.primary95",
        color: "mockup.neutral10",
        "& .MuiAlert-icon": { color: "primary.main" },
      }}
    >
      {t("group.importSyncedClassWarning")}
    </Alert>
  )
}

export default SyncedClassWarning
